import React, { useEffect } from "react";
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";
const PrimeCatcher = () => {
  useEffect(() => {
    const canvas = document.getElementById("gameCanvas");
    const ctx = canvas.getContext("2d");
    const scoreDisplay = document.getElementById("scoreboard");

    let score = 0;
    let numbers = [];
    const boxSize = 40;

    function isPrime(n) {
      if (n < 2) return false;
      for (let i = 2; i <= Math.sqrt(n); i++) {
        if (n % i === 0) return false;
      }
      return true;
    }

    function spawnNumber() {
      const value = Math.floor(Math.random() * 50) + 1;
      numbers.push({
        x: Math.random() * (canvas.width - boxSize),
        y: 0,
        value: value,
        isPrime: isPrime(value),
        clicked: false
      });
    }

    function drawNumbers() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      numbers.forEach(n => {
        if (!n.clicked) {
          ctx.fillStyle = "#1976d2";
          ctx.fillRect(n.x, n.y, boxSize, boxSize);
          ctx.fillStyle = "#fff";
          ctx.font = "20px Arial";
          ctx.fillText(n.value, n.x + 10, n.y + 25);
        }
      });
    }

    function updateNumbers() {
      numbers.forEach(n => {
        if (!n.clicked) {
          n.y += 2;
        }
      });
    }

    function updateScore(change) {
      score += change;
      scoreDisplay.innerText = `Score: ${score}`;
      console.log("hi",score)
      if(score==10){
        const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      }
    }

    function handleClick(event) {
      const rect = canvas.getBoundingClientRect();
      const clickX = event.clientX - rect.left;
      const clickY = event.clientY - rect.top;

      numbers.forEach(n => {
        if (
          !n.clicked &&
          clickX >= n.x && clickX <= n.x + boxSize &&
          clickY >= n.y && clickY <= n.y + boxSize
        ) {
          if (n.isPrime) {
            updateScore(1);
          } else {
            updateScore(-1);
          }
          n.clicked = true;
        }
      });
    }

    canvas.addEventListener("click", handleClick);

    const spawnInterval = setInterval(spawnNumber, 1200);
    const loopInterval = setInterval(() => {
      updateNumbers();
      drawNumbers();
    }, 30);

    return () => {
      canvas.removeEventListener("click", handleClick);
      clearInterval(spawnInterval);
      clearInterval(loopInterval);
    };
  }, []);

  const styles = {
    body: {
      margin: 0,
      fontFamily: "sans-serif",
      background: "#e0f7fa",
      overflow: "hidden",
      textAlign: "center"
    },
    header: {
      background: "#00796b",
      color: "white",
      margin: 0,
      padding: "10px"
    },
    scoreboard: {
      fontSize: "20px",
      marginTop: "10px",
      color: "#00796b"
    },
    canvas: {
      background: "#ffffff",
      display: "block",
      margin: "0 auto"
    }
  };

  return (
    <div style={styles.body}>
      <h2 style={styles.header}>🎯 Prime Catcher</h2>
      <div id="scoreboard" style={styles.scoreboard}>Score: 0</div>
      <canvas id="gameCanvas" width={400} height={600} style={styles.canvas}></canvas>
    </div>
  );
};

export default PrimeCatcher;
